
/*sj : 추가 !header 백그라운드 컨트롤 함수 */

/*header 백그라운드 컨트롤 */

//치타 chit-stickybg-section 시작
$(function() {
    const chitStickyBgBackPosi = document.querySelector('.chit-stickybg-back-posi')
    const chitStickyBgRightBox = document.querySelectorAll('.chit-stickybg-right-box')

    if(document.querySelector('.chit-stickybg-mo-swiper')){
        const chitStickyMoSwiper = new Swiper('.chit-stickybg-mo-swiper', {
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            spaceBetween: 20,
            speed: 1000
        });
    }

    if (window.innerWidth < 768) {

    } else {
        gsap.to(".chit-stickybg-right-box1", {
            scrollTrigger: {
                trigger: ".chit-stickybg-right-box1",
                markers: false,
                start: "center center",
                end: "center center",
                scrub: true,
                onEnter: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[0].classList.add('active')
                },
                onEnterBack: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[0].classList.add('active')
                    chitStickyBgBackPosi.classList.remove('active2')
                    chitStickyBgBackPosi.classList.add('active1')
                }
            }
        });
        gsap.to(".chit-stickybg-right-box2", {
            scrollTrigger: {
                trigger: ".chit-stickybg-right-box2",
                markers: false,
                start: "center center",
                end: "center center",
                scrub: true,
                onEnter: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[2].classList.add('active')
                },
                onEnterBack: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[2].classList.add('active')
                }
            }
        });
        gsap.to(".chit-stickybg-right-box3", {
            scrollTrigger: {
                trigger: ".chit-stickybg-right-box3",
                markers: false,
                start: "center center",
                end: "center center",
                scrub: true,
                onEnter: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[1].classList.add('active')

                    chitStickyBgBackPosi.classList.remove('active1')
                    chitStickyBgBackPosi.classList.add('active2')
                },
                onEnterBack: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[1].classList.add('active')
                }
            }
        });
        gsap.to(".chit-stickybg-right-box4", {
            scrollTrigger: {
                trigger: ".chit-stickybg-right-box4",
                markers: false,
                start: "center center",
                end: "center center",
                scrub: true,
                onEnter: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[3].classList.add('active')
                },
                onEnterBack: function(){
                    for(let i = 0; i<chitStickyBgRightBox.length; i++){
                        chitStickyBgRightBox[i].classList.remove('active')
                    }
                    chitStickyBgRightBox[3].classList.add('active')
                }
            }
        });
    }
})


//치타 chit-stickybg-section 끝

// **section 05 시작
const sc5SwiperMenu = ['DIGITAL', 'VIRAL', 'SNS', 'LOCAL', 'PERSONAL']
const showSwiper05_text01 = document.querySelectorAll('.swiper-text_box')

const swipersection05 = new Swiper('.sc5-swiper', {
    pagination: {
        el: '.sc5-swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (sc5SwiperMenu[index]) + '</span>';
        }
    },
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    on: {
        slideChange: function (swiper) {

            for (let i = 0; i < showSwiper05_text01.length; i++) {
                if (i == swiper.activeIndex) {
                    if(showSwiper05_text01) {
                        showSwiper05_text01[i].classList.add('active');
                    }

                } else {
                    if(showSwiper05_text01) {

                        showSwiper05_text01[i].classList.remove('active')
                    }
                }
            }
            console.log(swiper)
            sc5NumbSwiper.slideTo(swiper.activeIndex);
        }
    }
});

const sc5NumbSwiper = new Swiper('.number-swiper', {
    touchRatio: 0,
    speed: 1000
});

const sc5PrevBtn = document.querySelector('.sc5-prev-btn ');
const sc5NextBtn = document.querySelector('.sc5-next-btn ');

if(sc5PrevBtn) {
    sc5PrevBtn.addEventListener('click',()=>{
        swipersection05.slidePrev();
    })
}

if(sc5NextBtn) {
    sc5NextBtn.addEventListener('click',()=>{
        swipersection05.slideNext();
    })
}


// **section 05 끝

// **section04 시작
const swipersection04 = new Swiper(".phone_swiper", {
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    pagination: {
        el: '.bullets_swiper',
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
// **section04 끝



window.onload = () => {

    // if(window.innerWidth < 768) {
    //     mobileScrollEvent();
    // }else {
    //     scrollEvent();
    // }
    AOS.init();

}
